import 'angular:locale/data:nl-BE';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "nl-BE";
